import baseHeaderPage from './modules/header';
import lookup from './modules/lookup-no-utils';

baseHeaderPage();
lookup();
